import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#3f51b5',
        secondary: '#b12009',
        accent: '#e9aa00',
        error: '#b71c1c'
      }
    }
  }
})
